import { render, staticRenderFns } from "./AccordionContent.vue?vue&type=template&id=bb1d6a1a&scoped=true"
import script from "./AccordionContent.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionContent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AccordionContent.vue?vue&type=style&index=0&id=bb1d6a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1d6a1a",
  null
  
)

export default component.exports